import { StyledBox } from '../styledBox/StyledBox'

export const StyledBoxEmphatic = StyledBox.extend`
  overflow: hidden;
`



// WEBPACK FOOTER //
// ./src/node_modules/components/HamburgerEmphaticReverse/StyledBoxEmphatic.js